import { Component, OnInit } from '@angular/core';
import { ModalService, MODAL } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { GTM } from 'src/app/services/gtm.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { HbmApiService } from 'src/app/services/hbm/hbm-api.service';
import { faEnvelope, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { HostListener } from '@angular/core';

@Component({
  selector: 'ng-casto-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  public inputs: any;
  public globalError: string = '';
  public isLoading: boolean;

  faEnvelope = faEnvelope;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  showPassword = false;

  private _displayForgotPassword = false;

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent): void {
    if (this.isLoading) {
      return;
    }
    event.preventDefault();
    this.submit();
  }

  get displayForgotPassword(): boolean {
    return this._displayForgotPassword;
  }

  set displayForgotPassword(value: boolean) {
    if (value === this._displayForgotPassword) return;
    this._displayForgotPassword = value;
  }

  loginCallBack: Function;

  constructor(
    public modalService: ModalService,
    private readonly customer: CustomerService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly hbmService: HbmApiService
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/se-connecter`, 'Se connecter');
    if (this.modalService.currentDatas) this.loginCallBack = this.modalService.currentDatas.loginCallBack;
    this.inputs = {
      login: {
        value: '',
        error: '',
      },
      captcha: {
        value: '',
        error: '',
      },
      password: {
        value: '',
        error: '',
      },
      lostPasswordEmail: {
        value: '',
        error: '',
      },
    };

    // fake login
    if (environment.configurators2d.global.debug.fakeCustomer) {
      this.customer.userDatas = environment.configurators2d.global.debug.data.customer;
      this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'token')
        .then(() => {
          if (this.loginCallBack) {
            this.loginCallBack();
          } else {
            this.modalService.close();
          }
        });
    }
  }

  resetInputError(): void {
    this.globalError = '';
    for (let key in this.inputs) {
      this.inputs[key].error = '';
    }
  }

  close(): void {
    this.modalService.close();
  }

  subscribe(): void {
    this.modalService.display(MODAL.REGISTER_CUSTOMER, {
      loginCallBack: this.loginCallBack,
    });
  }

  async submit(): Promise<void> {
    this.gtm.trackEvent('se-connecter');
    this.isLoading = true;
    this.resetInputError();

    if (this.displayForgotPassword) {
      try {
        await this.customer.forgottenPassword(this.inputs.lostPasswordEmail.value);
      } catch (err) {
        logError(err);
      } finally {
        this.isLoading = false;
        this.modalService.display(MODAL.CONFIRM_FORGOTTEN_PASSWORD);
      }
    } else {
      try {
        await this.customer.login(this.inputs.login.value, this.inputs.password.value);
        await this.hbmService.acquireTokenWS(this.customer.userDatas.id, 'token');
        if (this.loginCallBack) {
          this.loginCallBack();
        } else {
          this.modalService.close();
        }
      } catch (err) {
        logError(err);
        this.globalError = 'Adresse email ou mot de passe incorrect';
      } finally {
        this.isLoading = false;
      }
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
